import { matchPath, useLocation } from "react-router";

export const useBasePath = () => {
  const { pathname } = useLocation();
  const match = matchPath<{ orgName?: string }>(pathname, {
    path: "/orgs/:orgName",
  });
  return match?.params.orgName !== undefined
    ? `/orgs/${match.params.orgName}`
    : "/manage";
};
